export const getFileExtensionWithDot = (filename: string) => {
  const parts = filename.split(".");
  return parts.length > 1 ? `.${parts.pop()}` : "";
};
export const formatFromSnakeCase = (str: string): string => {
  return str?.toUpperCase().replace(/_/g, " ");
};
